import { useBusinessSettingsContext } from '../../hooks/useBusinessSettingsContext'
import Checkout from '../Checkout'
import FashionCheckout from '../../storefronts/indumentaria-femenina/FashionCheckout'

function PublicCheckout() {
  const { activeProfile, loading } = useBusinessSettingsContext()

  if (loading && !activeProfile) {
    return null
  }

  if (activeProfile?.rubro === 'indumentaria' && (activeProfile?.subrubro || 'femenina') === 'femenina') {
    return <FashionCheckout />
  }

  return <Checkout />
}

export default PublicCheckout
